import {
  Environment,
  middlewareTypes,
  createFetchPolicyMiddleware,
  createErrorMiddleware,
  Store,
} from '@bingads-webui-react/overreact';
import type {
  MiddlewareCollection,
  NetworkRequestor,
} from '@bingads-webui-react/overreact';
import { schema } from './schema';

export const middlewares = {
  [middlewareTypes.FETCH_POLICY]: createFetchPolicyMiddleware(),
  [middlewareTypes.ERROR]: createErrorMiddleware(),
};

const store = new Store();
let env: Environment | null = null;

export const CC_ENVIRONMENT_TAG = 'ClientCenter_Endpoint';


export function getEnvironmentInstance(
  requestor: NetworkRequestor,
  customStore?: Store,
  customMiddlewares?: MiddlewareCollection
) {
  if (!env) {
    env = new Environment(
      requestor,
      schema,
      customStore || store,
      customMiddlewares || middlewares,
      CC_ENVIRONMENT_TAG
    );
  }

  // allow caller to update requestor
  env.networkRequestor = requestor;
  env.middlewares = customMiddlewares || middlewares;

  return env;
}


export function environmentLookupFn(environmentTag?: string) {
  return environmentTag === CC_ENVIRONMENT_TAG;
}
